import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {host} from '../../function/api'

const initialState = {
    users: [],
    loading: false,
    status: false,
    success: false,
    message: '',
    errorUser: '',
    error: '',
    errorType: '',
    errorValue: ''
}

// export const sendsmsToCustomer = createAsyncThunk(
//     'sendsmsToCustomer',
//     async(thunkAPI) => {
//         try {
//             const data = {
//                 'lineNumber': '30007732002850',
//                 'MessageText': ['تست'],
//                 'Mobiles': ['09111348858']
//             }
//             const response = await axios({
//                 method: 'POST',
//                 url: `https://api.sms.ir/v1/send/likeToLike`,
//                 data: data,
//                 headers: {
//                         'Accept': 'application/json',
//                         'X-API-KEY': 'c0bb2a6fd390d687daa52a70',
//                         // 'xsrfHeaderName': "X-XSRF-TOKEN",
//                         // 'withCredentials': true,
//                         // 'Authorization': `Bearer ${localStorage.getItem('token')}`
//                     }    
//                 })
                
//             return await response.data;
            
//         } catch (error) {
//             return thunkAPI.rejectWithValue(error);
//         }
//     }
// )
export const sendsmsToCustomer = createAsyncThunk(
    'sendsmsToCustomer',
    async(thunkAPI) => {
        try {
            const data = {
                'mobile': '09111348858'
            }
            const response = await axios({
                method: 'POST',
                url: `${host}document/request/confirmation`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
export const userSearch = createAsyncThunk(
    'userSearch',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}user/search`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const userList = createAsyncThunk(
    'user/list',
    async(thunkApi) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}user`,
                // data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data.data

        } catch(error) {
            return thunkApi.rejectWithValue(error)
        }
    }
) 

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers:{

    },
    extraReducers:{
        [sendsmsToCustomer.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = true
            console.log(200)
            console.log(action)
        },
        [sendsmsToCustomer.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
            console.log(300)
        },
        [sendsmsToCustomer.rejected]: (state, action) => {
            state.loading = false
            state.success = false
            state.status = false
            console.log(500)
            console.log(action)
        },
        [userList.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = true
            state.users = action.payload.data
        },
        [userList.pending]: (state) => {
            state.loading = true
            state.success = false
        },
        [userList.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            // console.log(payload)
            state.status = false
            if(payload.response.data.error){
                state.errorUser = payload.response.data.user
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [userSearch.fulfilled]: (state, action) => {

            state.loading = false
            state.success = true
            state.status = true
            state.users = action.payload.data
        },
        [userSearch.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
        },
        [userSearch.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = false
            if(payload.response.data.error){
                state.errorValue = payload.response.data.value
                state.errorType = payload.response.data.type
            }
            if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = userSlice.actions;
export default userSlice.reducer;